<template>
  <!-- Modal -->

  <b-modal id="depositViaPhoneCardModal" centered title="Nạp qua thẻ điện thoại" hide-footer>

    <div v-if="!website.popup_card_content" class="d-block text-center">
      <p> Bạn sẽ nhận được : <b class="text-danger"> {{ settings.discount_card }}%</b> giá trị tất cả các
        loại thẻ!
      </p>
      <p> VD : Nạp <b class="text-warning">100,000đ</b> sẽ nhận được <b
          class="text-danger"> {{ Helper.formatMoney((100000 / 100) * settings.discount_card) }}đ</b>!
      </p>
      <p :hidden="hideValue"><b class="text-warning">Lưu ý : </b>Vui lòng chọn đúng mệnh giá thẻ. Thẻ sai mệnh giá sẽ <b
          class="text-danger"> không được cộng tiền (mất thẻ)</b>
      </p>
    </div>
    <div v-else>
        <div v-html="website.popup_card_content"></div>
    </div>
    <topup-card-form :website="website"></topup-card-form>
    <!-- <b-button class="mt-3" block @click="$bvModal.hide('depositViaPhoneCardModal')">Đóng</b-button> -->
  </b-modal>
</template>

<script>
import TopupCardForm from "./TopupCardForm";

export default {
  components: {TopupCardForm},
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    website: {
      Type: Object,
      default() {
        return {};
      }
    },
    settings: {
      Type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        card_brand: '',
        value: '',
        code: '',
        serial: ''
      },
      hideValue: false,
    }
  },
  methods: {
    async deposit() {
      try {
        const uri = this.route('fe_card_charge', {domain: this.website.domain});
        const response = await this.Request.post(uri, this.form);

        if (response.data.status === false) {
          await this.$swal.fire(
              'Có lỗi xảy ra!',
              response.data.message,
              'error'
          );

        } else {
          await this.$swal.fire({
            timer: 1000,
            icon: "success",
            title: 'Thành Công!',
            html: response.data.message,
            showConfirmButton: false,
            width: '400px',
          });

          // location.reload();
        }
      } catch (e) {
        const errorMessages = this.Request.errors(e.response);
        await this.$swal.fire(
            'Có lỗi xảy ra!',
            errorMessages[0],
            'error'
        );
      }
    },
    changeBrand() {
      this.hideValue = (this.form.card_brand === "GATE" || this.form.card_brand === "iSEC")
    }
  }
}
</script>

<style scoped>

</style>
